import { useAppState } from "./useAppState";

export const useAuthState = (selectorFn) => useAppState((state) => selectorFn(state.auth));
